// Turns a camelCase or PascalCase key (e.g. an enum member name) into a
// spaced, human-readable label: "MinuteInterval" -> "Minute Interval".
export const formatPascalCaseLabel = (name) =>
  (name || '')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([a-zA-Z])([0-9])/g, '$1 $2')
    .trim()
